// extracted by mini-css-extract-plugin
export var sliderRange = "_rq-2";
export var sliderRoot = "_rq-0";
export var sliderThumb = "_rq-3";
export var sliderTrack = "_rq-1";